
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import PropTypes from 'prop-types';
import { createSelector } from "reselect";
import { getSwarmSubscriptionRequestPopularSports } from "../../../helpers/terminalRequests/popularSports";
import Helpers from "../../../helpers/helperFunctions";
import Loader from '../loader';
import { Link } from "react-router";
import { t } from '../../../helpers/translator';
import Config from "../../../config/main";

class PopularSports extends Component {
    render () {
        let { data } = this.props;
        return data ? data.map(sport => <Link key={sport.alias} className={sport.alias} to={`/prematch/${sport.alias}`}>
            <i className={Config.enablePopularSportIcons ? `sport-icon-m ${sport.alias === "3x3Basketball" ? "Basketball3x3"  :sport.alias}` : ''}>{t(sport.name)}</i>
            {Config.popularSportsGameCount && <span className="sport-icon-count">{sport.game}</span>}
        </Link>) : <Loader/>;
        //todo check after merge
    }
}

PopularSports.propTypes = {
    data: PropTypes.array
};

const mapStateToProps = (_) => {
    let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestPopularSports());
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify((() => {
                const sports = Helpers.objectToArray(state.swarmData.data[key].sport).sort((a, b) => a.order - b.order);
                return (Config.popularSportsShowCurrentActive ? sports.filter(item => item.game) : sports)
                    .slice(Config.main.popularGamesViewCount, Config.main.popularGamesCount);
            })())
        ],
        (data) => {
            return {
                data: data && JSON.parse(data)
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: PopularSports,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestPopularSports();
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestPopularSports());
        this.keepDataAfterUnsubscribe = true;
    }
}));